import React from "react";

// Returns a React SVG component so that we may change the fill color and/or icon size of the SVG to whatever we want dynamically across hundreds of different websites and hundreds of different colors.
// This react component is the box SVG icon, typically used for the Order CTA.

const WindshieldWipers = ({ color, svgIconSize }) => {
    return (
        <svg
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                width: svgIconSize,
                height: svgIconSize,
                pointerEvents: "none",
            }}
        >
            <g id="Windshield_and_Wiper" data-name="Windshield and Wiper" fill={color || "white"}>
                <path d="m44 11.8a1 1 0 0 0 -1-.8h-38a1 1 0 0 0 -1 .8c-4.14 20-4.32 20-3.83 20.71 3.12 8.57 44.27 8.57 47.59.09.6-.75.24-1.46-3.76-20.8zm-16.12 25.1 4.12-6.47v1.57a1 1 0 0 0 2 0v-8a1 1 0 0 0 -2 0v2.71l-6.54 10.29a74.89 74.89 0 0 1 -9.07-.35l3.61-6v1.35a1 1 0 0 0 2 0v-8a1 1 0 0 0 -2 0v2.72l-5.79 9.66c-7.43-1-11.74-3-12.19-4.66.06-.83-.38 1.45 3.79-18.72h17.19v1h-3a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h3a1 1 0 0 0 2 0h3a2 2 0 0 0 2-2v-2a2 2 0 0 0 -2-2h-3v-1h17.19c4.17 20.18 3.81 18.09 3.81 18.74-.56 1.98-7.06 4.64-18.12 5.16zm-7.88-18.9v-2h8v2z" />
            </g>
        </svg>
    );
};

export default WindshieldWipers;
